import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { StyledEngineProvider } from '@mui/material/styles';
import Routes from 'routes';
import store from 'state/store';
import initializeI18n from 'translations/translator';
import './App.css';

initializeI18n();

const LwtApp = () => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.origin.includes('lwtears.com') && !event.origin.includes('localhost')) return;
      if (event.data && event.data.type === 'applyStyle') {
        let style = document.getElementById(event.data.id);
        if (!style) {
          style = document.createElement('style');
          style.id = event.data.id;
          style.textContent = event.data.css;
          document.head.appendChild(style);
        }
      }

      if (event.data && event.data.type === 'removeStyle') {
        const style = document.getElementById(event.data.id);
        if (style) style.remove();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <Routes />
      </StyledEngineProvider>
    </Provider>
  );
};

export default LwtApp;
